// react
import React from 'react';

// data stubs
import theme from '../../data/theme';

export default function FooterContacts() {
    return (
        <div className="site-footer__widget footer-contacts">
            <h5 className="footer-contacts__title">Nuestra Ubicación</h5>

            <div className="footer-contacts__text">
                Nos encanta recibir a nuestros clientes, así que ven en cualquier momento
                durante las horas de oficina.
            </div>

            <ul className="footer-contacts__contacts">
                <li>
                    <i className="footer-contacts__icon fas fa-globe-americas" />
                    {theme.contacts.address}
                </li>
                <li>
                    <i className="footer-contacts__icon far fa-envelope" />
                    {theme.contacts.email}
                </li>
                <li>
                    <i className="footer-contacts__icon fas fa-phone-alt" />
                    {`${theme.contacts.phone}`}
                </li>
                <li>
                    <i className="footer-contacts__icon fas fa-mobile-alt" />
                    {`${theme.contacts.mobile}`}
                </li>
                <li>
                    <i className="footer-contacts__icon far fa-clock" />
                    Lunes-Sábado 09:00 - 18:00 UTC
                </li>
            </ul>
        </div>
    );
}
